// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ApiKeyCreatedOut = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "expired": zod.boolean(),
  "expires_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "key": zod.string(),
  "last_used_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "name": zod.string(),
  "scopes": zod.array(zod.string())
});

export type ApiKeyCreatedOut = zod.input<typeof ApiKeyCreatedOut>;
export type ApiKeyCreatedOutOutput = zod.output<typeof ApiKeyCreatedOut>;
